[
  {
    "id": 2,
    "Nome": "Ing. José Ceccarelli",
    "Titolo": "Educatore Cinofilo",
    "Contatto": "josemilubalu@gmail.com",
    "Indirizzo": "Via Baroni 14",
    "Citta": "Calderino di Monte San Pietro",
    "CAP": "40050",
    "Provincia": "BO",
    "ComuniAttivita": "Bologna e Provincia, Modena, Ravenna, Ferrara",
    "Lat": "44.652911",
    "Lon": "11.3747194",
    "Descrizione": null,
    "Email": "josemilubalu@gmail.com",
    "Telefono": "+39 3356895681",
    "published_at": "2025-02-22T08:01:59.157Z",
    "created_at": "2025-02-22T08:01:54.044Z",
    "updated_at": "2025-05-27T10:30:57.294Z"
  },
  {
    "id": 3,
    "Nome": "Carlotta Fabbri",
    "Titolo": "Educatore - Operatore Canile - Dog sitter ",
    "Contatto": "+39 3315098609",
    "Indirizzo": null,
    "Citta": "Rimini",
    "CAP": "47921",
    "Provincia": "RN",
    "ComuniAttivita": "Rimini, Poggio Torriana, Verucchio, Santarcangelo, Bellaria-Igea marina, San Marino, Coriano, Montescudo- Montecolombo, Riccione, San Clemente, Misano Adriatico, Cattolica, Morciano, Cesena, San Marino, Cesena, Rimini, Pesaro",
    "Lat": "44.0663147",
    "Lon": "12.56740284",
    "Descrizione": "<p>Mi chiamo Carlotta, ho 30 anni, dal 2022 sono educatrice Enci ma con metodo cognitivo relazionale, sono operatore di canile al canile comunale Stefano Cerni di Rimini e Vallecchio, faccio servizio di dog sitter e consulenze sul territorio di Rimini e provincia.<br>\nAttualmente sto frequentando il corso istruttori esperti in riabilitazione comportamentale Acsi.</p>\n",
    "Email": "dog.daily.routine@gmail.com",
    "Telefono": "+39 3315098609",
    "published_at": "2025-02-22T08:05:23.121Z",
    "created_at": "2025-02-22T08:05:18.629Z",
    "updated_at": "2025-04-19T10:03:47.182Z"
  },
  {
    "id": 4,
    "Nome": "Daniele Lissoni",
    "Titolo": "Centro Cinofilo - Educatore - Istruttore",
    "Contatto": "+39 3935309489",
    "Indirizzo": "Via san rocco 11 ",
    "Citta": "Truccazzano",
    "CAP": "20060",
    "Provincia": "MI",
    "ComuniAttivita": "Milano nord e ovest, Cremona, Brescia, Lodi, Bergamo",
    "Lat": "45.4901068",
    "Lon": "9.4710552",
    "Descrizione": "<p>Corsi di formazione per Educatori e Istruttori cinofili. Corso di educazione e rieducazione comportamentale. Mobility. Mantrailing. Lezioni singole e collettivo presso il nostro Centro Cinofilo, in ambito urbano o extraurbano.</p>\n",
    "Email": null,
    "Telefono": "+39 3935309489",
    "published_at": "2025-02-22T08:08:00.323Z",
    "created_at": "2025-02-22T08:07:58.054Z",
    "updated_at": "2025-02-22T10:04:35.569Z"
  },
  {
    "id": 5,
    "Nome": "Tania Serri",
    "Titolo": "Istruttore cinofilo ",
    "Contatto": "tania@magomerlino-dog.it ",
    "Indirizzo": "Via Casa storto 530",
    "Citta": "Serramazzoni",
    "CAP": "41028",
    "Provincia": "MO",
    "ComuniAttivita": "Modena, Padova",
    "Lat": "44.3893862",
    "Lon": "10.7544742",
    "Descrizione": "<p>Centro cinofilo, attività di educazione e rieducazione comportamentale. Mantrailing rally-o</p>\n",
    "Email": "tania@magomerlino-dog.it ",
    "Telefono": null,
    "published_at": "2025-02-22T08:09:38.638Z",
    "created_at": "2025-02-22T08:09:35.350Z",
    "updated_at": "2025-02-27T14:12:37.149Z"
  },
  {
    "id": 6,
    "Nome": "Lorenzo Dani",
    "Titolo": "Istruttore cinofilo",
    "Contatto": "+39 3334615627",
    "Indirizzo": "Corso roma 153",
    "Citta": "Cologno monzese",
    "CAP": "20092",
    "Provincia": "MI",
    "ComuniAttivita": "Milano e provincia",
    "Lat": "45.5364168",
    "Lon": "9.2846044",
    "Descrizione": "<p>Riabilitazione comportamentale</p>\n",
    "Email": null,
    "Telefono": "+39 3334615627",
    "published_at": "2025-02-22T08:11:04.394Z",
    "created_at": "2025-02-22T08:11:00.947Z",
    "updated_at": "2025-02-22T09:12:30.295Z"
  },
  {
    "id": 7,
    "Nome": "Cristina Tomelleri",
    "Titolo": "in formazione come istruttrice",
    "Contatto": "+39 3469451848",
    "Indirizzo": "Via Borgo Pio X, 38",
    "Citta": "San Giovanni Lupatoto ",
    "CAP": "37057",
    "Provincia": "VR",
    "ComuniAttivita": "Verona e provincia",
    "Lat": "45.3787779",
    "Lon": "11.0542792",
    "Descrizione": "<p>In formazione come istruttrice</p>\n",
    "Email": "cristinatomelleri@yahoo.it",
    "Telefono": "+39 3469451848",
    "published_at": "2025-02-22T08:14:04.976Z",
    "created_at": "2025-02-22T08:14:02.777Z",
    "updated_at": "2025-02-26T18:54:05.876Z"
  },
  {
    "id": 8,
    "Nome": "Davide Godi",
    "Titolo": "Istruttore cinofilo riabilitatore - docente/formatore",
    "Contatto": "anny.bernardelli76@gmail.com",
    "Indirizzo": "Strada Tizzore Inferiore 3, Scurano",
    "Citta": "Neviano degli Arduini",
    "CAP": "43024",
    "Provincia": "PR",
    "ComuniAttivita": "Parma",
    "Lat": "44.50187721",
    "Lon": "10.30636008",
    "Descrizione": "<p>Lavoro da circa 15 anni come istruttore cinofilo riabilitatore con approccio cognitivo zooantropologico sia presso canili che con i privati all' interno del sistema famiglia.\nSono docente in corsi di formazione per educatori e istruttori cinofili  e al MASTER in Istruzione cinofila e Medicina Comportamentale presso la Facoltà di medicina veterinaria dell Università di Parma. La mia pagina Facebook è : Essere cane centro cinofilo</p>\n",
    "Email": "anny.bernardelli76@gmail.com",
    "Telefono": null,
    "published_at": "2025-02-22T08:17:09.816Z",
    "created_at": "2025-02-22T08:17:06.932Z",
    "updated_at": "2025-02-22T09:12:19.091Z"
  },
  {
    "id": 9,
    "Nome": "Marco Laforgia Nigro",
    "Titolo": "Addestratore Cinofilo ENCI sez.1; Educatore Cinofilo Livello Avanzato OPES Cinofilia; Istruttore Riabilitatore; Tecnico UD-C Cognitiva",
    "Contatto": "marco75dogtrainer@gmail.com",
    "Indirizzo": "Via Cimabue, 19",
    "Citta": "Lentate sul Seveso",
    "CAP": "20823",
    "Provincia": "MB",
    "ComuniAttivita": "Monza Brianza, Como",
    "Lat": "45.67860003",
    "Lon": "9.13315719",
    "Descrizione": "<p>Mi chiamo Marco Laforgia Nigro e mi occupo principalmente di educazione cinofila e riabilitazione comportamentale del cane, collaboro con un importante centro Cinofilo in Provincia di Milano. L'utilizzo dei masticativi e più nello specifico, la masticazione prodotta da MASTICANDO è per me di fondamentale importanza in quanto mi facilità tanto nell'educazione quanto nella riabilitazione del cane. Questi masticativi sono la pietra miliare sulla quale poggia il mio metodo di lavoro.</p>\n",
    "Email": "marco75dogtrainer@gmail.com",
    "Telefono": null,
    "published_at": "2025-02-27T14:22:40.188Z",
    "created_at": "2025-02-27T14:16:36.068Z",
    "updated_at": "2025-02-27T14:22:40.196Z"
  },
  {
    "id": 10,
    "Nome": "Renato Roca",
    "Titolo": "Istruttore Cinofilo Riabilitatore",
    "Contatto": "+39 3206442585",
    "Indirizzo": "Via Vanda Cavalli 3",
    "Citta": "Premeno",
    "CAP": "28818",
    "Provincia": "VB",
    "ComuniAttivita": "Verbania, Novara, Varese",
    "Lat": "1",
    "Lon": "1",
    "Descrizione": "<p>Mi occupo di Educazione e Riabilitazione Comportamentale del Cane, sono Formatore Nazionale e Presidente di Amarok Lo Spirito del Lupo</p>\n",
    "Email": null,
    "Telefono": "+39 3206442585",
    "published_at": "2025-03-05T11:28:06.874Z",
    "created_at": "2025-03-05T11:28:03.306Z",
    "updated_at": "2025-03-05T11:28:06.881Z"
  },
  {
    "id": 11,
    "Nome": "Marco Bellia",
    "Titolo": "Esperto Cinofilo nell'area comportamentale ",
    "Contatto": "+39 3319508096",
    "Indirizzo": "VIA MASCAGNI N 16",
    "Citta": "Calusco d adda",
    "CAP": "24033",
    "Provincia": "BG",
    "ComuniAttivita": "Bergamo",
    "Lat": "1",
    "Lon": "1",
    "Descrizione": "<p>Educazione, relazione e benessere del cane in ambiente urbano e naturale, organizzo dogtrekking, classi di comunicazione ed esperienze utili a consolidare la relazione del binomio</p>\n",
    "Email": null,
    "Telefono": "+39 3319508096",
    "published_at": "2025-03-05T11:29:21.094Z",
    "created_at": "2025-03-05T11:29:18.127Z",
    "updated_at": "2025-03-05T11:29:21.101Z"
  },
  {
    "id": 12,
    "Nome": "Salvatore Tamburrini",
    "Titolo": "Educatore - Tecnico NSD",
    "Contatto": "+39 331 929 8472‬",
    "Indirizzo": ".",
    "Citta": "Varese",
    "CAP": ".",
    "Provincia": "VA",
    "ComuniAttivita": "Varese e provincia",
    "Lat": "",
    "Lon": "",
    "Descrizione": "<p>Sono un educatore cinofilo con approccio cognitivo-zooantropologico principalmente impegnato in educazione di base e avanzata e attività di Nosework, sono tecnico ACSI per le attività di Nosework Scent Detection (rilevamento sostanze sportivo). Sono anche Operatore di Primo Soccorso Veterinario e forte promotore della comprensione del cane e dell’armonia uomo-cane.</p>\n",
    "Email": "",
    "Telefono": "+39 331 929 8472‬",
    "published_at": "2025-04-19T10:02:45.564Z",
    "created_at": "2025-04-19T10:02:43.200Z",
    "updated_at": "2025-04-19T10:03:08.312Z"
  },
  {
    "id": 13,
    "Nome": "Daniela Nastasi",
    "Titolo": "Educatrice e Istruttrice CZ - Maia Centro Cinofilo",
    "Contatto": "+393284252412",
    "Indirizzo": ".",
    "Citta": "Siracusa",
    "CAP": ".",
    "Provincia": "SR",
    "ComuniAttivita": "Siracusa e provincia",
    "Lat": "",
    "Lon": "",
    "Descrizione": "<p>Educatrice ed Istruttrice per la relazione uomo-cane con approccio cognitivo-relazionale Siua-FISC.<br>\nAiuto le persone a capire e gestire meglio il proprio cane, rispettandone natura ed emozioni. Recupero comportamentale anche in caso di disagi come aggressività, fobie e insicurezze.<br>\nProprietaria e fondatrice del Centro Cinofilo Maia! dove abbiamo anche una pensione e asilo diurno in ambiente familiare e naturale, con percorsi personalizzati.<br>\nSito <a href=\"www.maiacentrocinofilo.com\">www.maiacentrocinofilo.com</a></p>\n",
    "Email": "maiacentrocinofilo@gmail.com",
    "Telefono": "+393284252412",
    "published_at": "2025-06-07T11:34:35.584Z",
    "created_at": "2025-06-07T11:33:52.474Z",
    "updated_at": "2025-06-07T11:34:35.592Z"
  },
  {
    "id": 14,
    "Nome": "Salvatore Rondinella",
    "Titolo": "Educatore Cinofilo",
    "Contatto": "rondinella.art@gmail.com",
    "Indirizzo": "-",
    "Citta": "Genzano di Roma",
    "CAP": "00045",
    "Provincia": "RM",
    "ComuniAttivita": "Castelli Romani (Genzano, Albano, Ariccia, Frascati, Velletri) e mi allargo fino ad Artena, Valmontone, Anzio",
    "Lat": null,
    "Lon": null,
    "Descrizione": "<p>Educatore cinofilo formato nella scuola ThinkDog. Accompagno persone e cani in percorsi basati sulla relazione, sull'ascolto e sull’esperienza condivisa.\nOrganizzo attività all’aria aperta come dog trekking e passeggiate educative, creando contesti di crescita, calma e connessione.\nCredo in un’educazione che mette al centro il benessere, l’autenticità e il legame profondo tra cane e umano.</p>\n",
    "Email": "rondinella.art@gmail.com",
    "Telefono": "+393881579183",
    "published_at": "2025-06-15T23:04:17.845Z",
    "created_at": "2025-06-15T23:04:15.182Z",
    "updated_at": "2025-06-15T23:04:17.853Z"
  },
  {
    "id": 15,
    "Nome": "Giulia Pinsone",
    "Titolo": "Educatrice Cinofila opes avanzato - Dog Sitter ",
    "Contatto": "giulia.edu.cinofila@gmail.com",
    "Indirizzo": "-",
    "Citta": "Roma",
    "CAP": "00100",
    "Provincia": "RM",
    "ComuniAttivita": "Roma e provincia ",
    "Lat": null,
    "Lon": null,
    "Descrizione": "<p>Mi chiamo Giulia e sono un’educatrice cinofila. Mi occupo di percorsi educativi, dog sitting in natura e passeggiate di gruppo.\nLavoro in contesti naturalistici, urbani e a domicilio in base alle esigenze del cane e del binomio.</p>\n",
    "Email": "giulia.edu.cinofila@gmail.com",
    "Telefono": "+393756218107",
    "published_at": "2025-06-15T23:06:10.019Z",
    "created_at": "2025-06-15T23:06:06.896Z",
    "updated_at": "2025-06-15T23:06:10.029Z"
  },
  {
    "id": 16,
    "Nome": "Colpo di Coda - Dott. Giuseppina Stumpo",
    "Titolo": "Medico Veterinario Comportamentalista, Counselor sistemico relazionale",
    "Contatto": "+39 339 520 0541",
    "Indirizzo": "Via Cofanara 75",
    "Citta": "Pozzuoli",
    "CAP": "80078",
    "Provincia": "NA",
    "ComuniAttivita": "Pozzuoli, Napoli",
    "Lat": null,
    "Lon": null,
    "Descrizione": "<p>Centro cinofilo.<br>\nAsilo per cani con<br>\n16 campi per diverse classi di comunicazione in natura<br>\nDog taxi<br>\nPercorsi educativi zooantropologici per migliorare la relazione tra uomo-animale<br>\nRiabilitazione comportamentale<br>\nMobility dog<br>\nPasseggiate e viaggi trekking a 6 zampe in percorsi naturalistici<br>\nSensibilizzazione al rapporto cane- persona attraverso incontri con esperti del settore aperti al pubblico<br>\nPiscina per cani<br>\nFattoria didattica<br>\nCorsi per educatori</p>\n",
    "Email": null,
    "Telefono": "+39 339 520 0541",
    "published_at": "2025-06-23T07:53:10.362Z",
    "created_at": "2025-06-23T07:53:06.817Z",
    "updated_at": "2025-06-28T14:04:26.743Z"
  },
  {
    "id": 17,
    "Nome": "Dog’s life asd",
    "Titolo": "Associazione",
    "Contatto": "3483536904",
    "Indirizzo": "Via guglianese snc",
    "Citta": "Pistoia",
    "CAP": "51100",
    "Provincia": "PT",
    "ComuniAttivita": "Pistoia e dintorni",
    "Lat": null,
    "Lon": null,
    "Descrizione": "<p>Ci occupiamo di educazione cinofila, recupero comportamentale, dog trekking, classi di comunicazione, asilo diurno, adozioni e stallo di cani, monility, dog trekking, vacanze a sei zampe, zooantropologia didattica, corsi di formazione</p>\n",
    "Email": "doglifeasd@gmail.com",
    "Telefono": "+393483536904",
    "published_at": "2025-07-28T14:48:19.846Z",
    "created_at": "2025-07-28T14:48:17.299Z",
    "updated_at": "2025-07-28T14:48:19.855Z"
  },
  {
    "id": 18,
    "Nome": "Laura Menga",
    "Titolo": "Educatore Cinofilo",
    "Contatto": "riconosciamoci.doglife@gmail.com",
    "Indirizzo": null,
    "Citta": "Lodi",
    "CAP": "26900",
    "Provincia": "LO",
    "ComuniAttivita": "Lodi, Crema, Milano sud-est, Piacenza",
    "Lat": null,
    "Lon": null,
    "Descrizione": "<p>Educatrice cinofila, Tecnico Scatola Cognitiva, in formazione per Tecnico di Mobility Istruttore Cinofilo e Tecnico di vasca.<br>\nVolontaria presso varie associazioni.<br>\nAsilo diurno casalingo a Lodi<br>\nDag- Sitting<br>\nSeminari cinofili</p>\n",
    "Email": "riconosciamoci.doglife@gmail.com",
    "Telefono": "+393496926765",
    "published_at": "2025-07-28T14:52:02.396Z",
    "created_at": "2025-07-28T14:51:59.205Z",
    "updated_at": "2025-07-28T14:52:02.403Z"
  },
  {
    "id": 19,
    "Nome": "Rocco Carà",
    "Titolo": "Educatore Cinofilo",
    "Contatto": "+393343908256",
    "Indirizzo": "Via cascina lunga 3",
    "Citta": "Suno",
    "CAP": "28019",
    "Provincia": "NO",
    "ComuniAttivita": "Suno",
    "Lat": null,
    "Lon": null,
    "Descrizione": "<p>Educatore cinofilo specializzato in attività olfattive e attività sportive. Responsabile nazionale per la detection sportiva FISC.</p>\n",
    "Email": "roccocara18@gmail.com",
    "Telefono": "+393343908256",
    "published_at": "2025-07-28T14:54:56.041Z",
    "created_at": "2025-07-28T14:54:53.819Z",
    "updated_at": "2025-07-28T14:54:56.048Z"
  },
  {
    "id": 20,
    "Nome": "Moseka",
    "Titolo": "Educatrice/Istrutrice cinofila CZ",
    "Contatto": "moseka.masticando@gmail.com",
    "Indirizzo": null,
    "Citta": "Roma",
    "CAP": "00100",
    "Provincia": "RM",
    "ComuniAttivita": "Roma",
    "Lat": null,
    "Lon": null,
    "Descrizione": "<p>Esperta in recupero comportamentale.<br>\nFormata per la  gestione di cani diversamente abili: ciechi e sordi.<br>\nEsperta in attività ludico educative, dog trekking, passeggiate esperienziali, comunicazione interspecifica e intraspecifica.<br>\nVolontaria TBF  ODV.<br>\nOrganizzatrice attività mirate al benessere del cane per una sana relazione uomo-cane e per il giusto inserimento nella nostra società.</p>\n",
    "Email": "moseka.masticando@gmail.com",
    "Telefono": "+393926239775",
    "published_at": "2025-07-29T05:22:58.069Z",
    "created_at": "2025-07-29T05:22:55.690Z",
    "updated_at": "2025-07-29T05:22:58.076Z"
  }
]